var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5065 1.99996V2.39579H10.9023H13.569C13.6408 2.39579 13.7097 2.42433 13.7605 2.47512C13.8113 2.52591 13.8398 2.5948 13.8398 2.66663V13.3333C13.8398 13.4051 13.8113 13.474 13.7605 13.5248C13.7097 13.5756 13.6408 13.6041 13.569 13.6041H1.56898C1.49715 13.6041 1.42826 13.5756 1.37747 13.5248C1.32668 13.474 1.29815 13.4051 1.29815 13.3333V2.66663C1.29815 2.5948 1.32668 2.52591 1.37747 2.47512C1.42826 2.42433 1.49715 2.39579 1.56898 2.39579H4.23565H4.63148V1.99996V1.06246H5.17315V1.99996V2.39579H5.56898H9.56898H9.96481V1.99996V1.06246H10.5065V1.99996ZM9.96481 3.33329V2.93746H9.56898H5.56898H5.17315V3.33329V4.27079H4.63148V3.33329V2.93746H4.23565H2.23565H1.83981V3.33329V5.99996V6.39579H2.23565H12.9023H13.2981V5.99996V3.33329V2.93746H12.9023H10.9023H10.5065V3.33329V4.27079H9.96481V3.33329ZM13.2981 7.33329V6.93746H12.9023H2.23565H1.83981V7.33329V12.6666V13.0625H2.23565H12.9023H13.2981V12.6666V7.33329Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.791667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.48fc05b910f29d110cd8ec25db92765a.svg";
export { ForwardRef as ReactComponent };